import { Document } from '../../jurisdiction/jurisdiction.domain';
import { GridApplicationDocumentTypes } from './enums/grid-application-document-types.enum';

export class IntegratedGridProtectionDocument {
  constructor(type: string) {
    this.unit_type = type;
    this.documents = [
      new Document(GridApplicationDocumentTypes.IntegratedCertificate),
      new Document(GridApplicationDocumentTypes.IntegratedAudit),
    ];
  }

  id: number;
  power_protection_id: number;
  documents: Document[];
  unit_type: string;
}
